;(function () {
  window.Ateed.Components.HeaderMicro.LevelTwoSurplusCounter = function() {
    var self = this;
    this.$container = $('.ateed-header-nav');

    this.onLevelTwoChange = function(callback) {

        var $levelTwo = $('.ateed-header-micro-nav-bar');
        var $listItems = $levelTwo.find('> li');

        //Calculate width of list
        var listWidth = 0;
        $listItems.each(function() {
            var $li = $(this);
            listWidth += $li.width();
        });
        listWidth += ($listItems.length-1) * 30; //Add 30 margin

        var containerWidth = $levelTwo.width();
        var migrationCount = 0;

        if (listWidth > containerWidth) {
            var difference = listWidth - containerWidth;
            $($listItems.get().reverse()).each(function(s, a) {
                if(difference >= 0) {
                    migrationCount++;
                }
                difference -= ($(this).width() + 30);
            });
        }

        callback(migrationCount);

        setTimeout(function() {
            var $levelTwo = $('.ateed-header-micro-nav-bar');
            var $listItems = $levelTwo.find('> li');
            var listWidth = 0;
            $listItems.each(function() {

                var $li = $(this);
                if ($li.css('display') !== 'none') {
                    listWidth += $li.width();
                }
            });
          $('.triple-dots').css({ 'left': listWidth + 30 });
        }, 0);
    };
  };
})();
